import * as React from 'react';
import { cn } from '@/lib/utils';
import type { LucideIcon } from 'lucide-react';

export interface InlineMetaProps extends React.HTMLAttributes<HTMLDivElement> {
  icon?: LucideIcon;
  label?: string;
}

export const InlineMeta = React.forwardRef<HTMLDivElement, InlineMetaProps>(
  ({ icon: Icon, label, className, children, ...props }, ref) => {
    return (
      <div
        ref={ref}
        className={cn(
          'flex items-center gap-1.5 text-microcopy text-muted-foreground',
          className
        )}
        {...props}
      >
        {Icon && <Icon className="w-3.5 h-3.5 flex-shrink-0" strokeWidth={1.5} />}
        {(label || children) && (
          <span className="truncate">{children ?? label}</span>
        )}
      </div>
    );
  }
);
InlineMeta.displayName = 'InlineMeta';
